export default "__VITE_ASSET__jFEwmWzw__"